module.exports = __webpack_public_path__ + "img/SKMJ_checkk2.443cc7f6.jpg";